<template>
  <div class="user">
    <div class="header bg-color-red acea-row row-between-wrapper">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="pictrue"><img :src="userInfo.avatar" /></div>
        <div class="text">
          <div class="acea-row row-middle">
            <div class="name line1">{{ userInfo.real_name }}</div>
            <div class="member acea-row row-middle" v-if="userInfo.vip">
              <img :src="userInfo.vip_icon" />{{ userInfo.vip_name }}
            </div>
          </div>
          <router-link :to="'/user/data'" class="id" v-if="userInfo.phone">
            ID：{{ userInfo.nickname }}<span class="iconfont icon-bianji1"></span>
          </router-link>
          <router-link :to="'/user/binding'" class="binding" v-else>
            <span>绑定手机号</span>
          </router-link>
        </div>
      </div>
      <span
        class="iconfont icon-shezhi"
        @click="$router.push({ path: '/user/data' })"
      ></span>
    </div>
    <div class="wrapper">
      <div
        class="wrapper"
        style="
          color: rgb(227, 213, 174);
          font-size: 0.28rem;
          z-index: 2;
          width: 6.92rem;
          height: 1.15rem;
          margin: 0px auto;
          background-color: rgb(74, 62, 44);
          border-radius: 0.2rem 0.2rem 0px 0px;
        "
      >
        <div class="acea-row row-middle clearfix" style="height: 1.15rem">
          <div class="fl" style="width: 3.34rem; margin-left: 0.1rem">
            等级：{{ userInfo.vip_name ? userInfo.vip_name : '新用户' }}
          </div>
          <div class="fr" style="width: 3rem; text-align: right">职级：{{ userInfo.group_name }}</div>
        </div>
      </div>
      <div class="nav acea-row row-middle">
          <router-link :to="{ path: '/user/bill/0' }" class="item">
          <div>消费账户</div>
          <div class="num">{{ userInfo.now_money || 0 }}</div>
        </router-link>
        <div @click="goPagey('/user/bill/1')" class="item">
          <div>体验账户</div>
          <div class="num">{{ userInfo.t_money || 0 }}</div>
        </div>
        <router-link :to="'/user/bill/2'" class="item">
          <div>奖励额度</div>
          <div class="num">{{ userInfo.integral || 0 }}</div>
        </router-link>
        <router-link :to="'/user/bill/3'" class="item">
          <div>电子账户</div>
          <div class="num">{{ userInfo.d_money || 0 }}</div>
        </router-link>
      </div>
      <div class="myOrder">
        <div class="title acea-row row-between-wrapper">
          <div>我的订单</div>
          <router-link :to="'/order/list/'" class="allOrder">
            全部订单<span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
        <div class="orderState acea-row row-middle">
          <router-link :to="{ path: '/order/list/' + 0 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfk.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.unpaid_count > 0"
                >{{ orderStatusNum.unpaid_count }}</span
              >
            </div>
            <div>待付款</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 1 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.unshipped_count > 0"
                >{{ orderStatusNum.unshipped_count }}</span
              >
            </div>
            <div>待发货</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 2 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dsh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.received_count > 0"
                >{{ orderStatusNum.received_count }}</span
              >
            </div>
            <div>待收货</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 3 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dpj.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.evaluated_count > 0"
                >{{ orderStatusNum.evaluated_count }}</span
              >
            </div>
            <div>待评价</div>
          </router-link>
          <router-link :to="'/order/refund_list'" class="item">
            <div class="pictrue">
              <img src="@assets/images/sh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.refund_count > 0"
                >{{ orderStatusNum.refund_count }}</span
              >
            </div>
            <div>售后/退款</div>
          </router-link>
        </div>
      </div>
	  <div class="myService"> 
	    <div class="title acea-row row-between-wrapper">
	      <div>我的优先股</div>
	      <!-- <router-link :to="'/order/list/'" class="allOrder" style="color: white;font-size: 0.26rem;">
	        更多<span class="iconfont icon-jiantou" style="font-size: 0.25rem;"></span>
	      </router-link> -->
	    </div>
	    <div class="nav acea-row row-middle">
	      <router-link :to="'/user/gu_you'" class="item">
	        <div class="num">{{ userInfo.gu_you || 0 }}</div>
	        <div>优先股</div>
	      </router-link>
		  <router-link :to="'/user/bill/7'" class="item"> 
	        <div class="num">{{ userInfo.f_money || 0 }}</div>
	        <div>优先股分红</div>
	      </router-link>
	     <div class="item">
	        <div class="num">0</div>
	        <div>交易开发中</div>
	      </div>
	    </div> 
	  </div>
      <div class="myService">
        <div class="title acea-row row-middle">我的分红股</div>

        <div class="nav acea-row row-middle">
          <div class="item">
            <div class="num">{{ userInfo.gu_total || 0 }}</div>
            <div>加权分红股</div>
          </div>
          <div class="item">
            <div class="num">{{ userInfo.gu_geren || 0 }}</div>
            <div>个人分红股</div>
          </div>
          <div class="item">
            <div class="num">{{ userInfo.gu_jiaquan || 0 }}</div>
            <div>推荐分红股</div>
          </div>
        </div>
        <div class="nav acea-row row-middle">
          <div class="item">
            <div class="num">{{ userInfo.tuidui_total || 0 }}</div>
            <div>总共分红股</div>
          </div>
          <div class="item">
            <div class="num">{{ userInfo.leftcount || 0 }}</div>
            <div>左区分红股</div>
          </div>
          <div class="item">
            <div class="num">{{ userInfo.rightcount || 0 }}</div>
            <div>右区分红股</div>
          </div>
        </div>
      </div>
      <div class="myService">
        <div class="title acea-row row-middle">我的服务</div>
        <div class="serviceList acea-row row-middle">
          <template v-for="(item, index) in MyMenus">
            <div
              class="item"
              :key="index"
              @click="goPages(index)"
              v-if="item.wap_url"
            >
              <div class="pictrue">
                <img :src="item.pic" />
              </div>
              <div>{{ item.name }}</div>
            </div>
          </template>
          <router-link
            :to="{ path: '/register/0/1'}"
            class="item"
          v-if="userInfo.is_promoter">
            <div>
              <div class="pictrue">
                <img src="@assets/images/user.png" />
              </div>
              <div>注册会员</div>
            </div>
          </router-link>
          <router-link
            :to="{ path: '/user/bduser'}"
            class="item"
            v-if="userInfo.is_promoter">
            <div>
              <div class="pictrue">
                <img src="@assets/images/user_jilu.png" />
              </div>
              <div>开通记录</div>
            </div>
          </router-link>
          <!--<div-->
          <!--class="item"-->
          <!--@click="changeswitch(true)"-->
          <!--v-if="userInfo.phone && isWeixin"-->
          <!--&gt;-->
          <!--<div class="pictrue"><img src="@assets/images/switch.png" /></div>-->
          <!--<div>账号切换</div>-->
          <!--</div>-->
        </div>
      </div>
    </div>
    <img src="@assets/images/support.png" class="support" />
    <div class="footer-line-height"></div>
    <SwitchWindow
      v-on:changeswitch="changeswitch"
      :switchActive="switchActive"
      :login_type="userInfo.login_type"
    ></SwitchWindow>
  </div>
</template>
<script>
import { getUser, getMenuUser } from "@api/user";
import { isWeixin } from "@utils";
import SwitchWindow from "@components/SwitchWindow";

const NAME = "User";

export default {
  name: NAME,
  components: {
    SwitchWindow
  },
  props: {},
  data: function() {
    return {
      userInfo: {},
      MyMenus: [],
      orderStatusNum: {},
      switchActive: false,
      isWeixin: false
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) this.User();
    }
  },
  mounted: function() {
    this.User();
    this.MenuUser();
    this.isWeixin = isWeixin();
  },
  methods: {
    changeswitch: function(data) {
      this.switchActive = data;
    },
    User: function() {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
        that.orderStatusNum = res.data.orderStatusNum;
      });
    },
    MenuUser: function() {
      let that = this;
      getMenuUser().then(res => {
        that.MyMenus = res.data.routine_my_menus;
      });
    },
    goPages: function(index) {
      let url = this.MyMenus[index].wap_url;
      if (url === "/user/user_promotion" && this.userInfo.statu === 1) {
        if (!this.userInfo.is_promoter)
          return this.$dialog.toast({ mes: "您还没有推广权限！！" });
      }
      if (url === "/customer/index" && !this.userInfo.adminid) {
        return this.$dialog.toast({ mes: "您还不是客服！！" });
      }

      this.$router.push({ path: this.MyMenus[index].wap_url });
    }
  }
};
</script>

<style scoped>
.footer-line-height {
  height: 1rem;
}
.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #ee5a52;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 0.2rem;
  padding: 0 0.08rem;
  border: 1px solid #ee5a52;
}

.pictrue {
  position: relative;
}
.switch-h5 {
  margin-left: 0.2rem;
}
.binding {
  padding: 0.05rem 0.2rem;
  background-color: #ca1f10;
  border-radius: 50px;
  font-size: 0.14rem;
  border: 1px solid #e8695e;
  color: #ffffff;
}
</style>
